export const filterNevermatch = `centerId: "NEVERMATCH"`;
export class FilterBuilder {
  filter = '';

  /**
   * Appends to filter string.
   * @param str The filter value to append.
   */
  appendFilter(str: string) {
    const appendText = this.filter.length > 0 ? ` OR ${str}` : str;
    this.filter += appendText;
  }
  /**
   * Whether or not a filter has been appended.
   */
  hasFilter(): boolean {
    return this.filter.length > 0;
  }
  /**
   * Updates to a filter string that matches nothing.
   */
  setNeverMatch() {
    this.filter = filterNevermatch;
  }
  /**
   * Returns current filter value.
   * @returns This object represented as a string.
   */
  toString(): string {
    return this.filter;
  }
}
